<mat-icon (click)="sendEmail(template,data)" color="primary"> mail_outline</mat-icon>
